import React, { useState } from 'react';
import { api } from '@/lib/api';
import { ShareNetwork, Copy, Lock } from '@phosphor-icons/react';

export const ShareModal = ({ caseId, onClose }) => {
  const [shareLink, setShareLink] = useState(null);
  const [sharePassword, setSharePassword] = useState('');
  const [creatingShare, setCreatingShare] = useState(false);

  const createShareLink = async () => {
    setCreatingShare(true);
    try {
      const { data } = await api.post(`/cases/${caseId}/share`, { password: sharePassword || null, expires_hours: 72 });
      setShareLink(data);
    } catch (err) {
      alert('Failed to create share link');
    } finally {
      setCreatingShare(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-lg w-full max-w-md p-6 border border-[#E5E7EB]" onClick={e => e.stopPropagation()} data-testid="share-modal">
        <h2 className="font-outfit text-xl font-bold text-[#09090B] mb-4 flex items-center gap-2"><ShareNetwork size={20} /> Share Case</h2>
        {shareLink ? (
          <div className="space-y-4">
            <div className="p-3 bg-green-50 border border-green-200 rounded-md">
              <p className="text-sm text-green-700 font-ibm font-semibold mb-1">Share link created!</p>
              <p className="text-xs text-green-600 font-ibm">Expires: {new Date(shareLink.expires_at).toLocaleDateString()}</p>
            </div>
            <div className="flex gap-2">
              <input readOnly value={`${window.location.origin}/shared/${shareLink.token}`}
                className="flex-1 px-3 py-2 border border-[#E5E7EB] rounded-md text-sm font-mono bg-[#F9FAFB]" />
              <button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/shared/${shareLink.token}`); }}
                className="px-3 py-2 bg-[#002FA7] text-white rounded-md hover:bg-[#00237D] transition-all" data-testid="copy-share-link">
                <Copy size={16} />
              </button>
            </div>
            {shareLink.has_password && <p className="text-xs text-[#6B7280] font-ibm flex items-center gap-1"><Lock size={12} /> Password protected</p>}
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-[#6B7280] font-ibm">Create a read-only link to share this case with an attorney, board member, or collaborator.</p>
            <div>
              <label className="block text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] mb-2 font-ibm">Password Protection (Optional)</label>
              <input data-testid="share-password-input" type="text" value={sharePassword} onChange={e => setSharePassword(e.target.value)} placeholder="Leave empty for no password"
                className="w-full px-3 py-2.5 border border-[#E5E7EB] rounded-md font-ibm text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
            </div>
            <div className="flex gap-2 justify-end">
              <button onClick={onClose} className="px-4 py-2 border border-[#E5E7EB] text-[#09090B] font-ibm text-sm rounded-md hover:bg-[#F3F4F6]">Cancel</button>
              <button data-testid="create-share-link-button" onClick={createShareLink} disabled={creatingShare}
                className="px-4 py-2 bg-[#002FA7] text-white font-ibm text-sm font-semibold rounded-md hover:bg-[#00237D] disabled:opacity-50 transition-all">
                {creatingShare ? 'Creating...' : 'Create Link'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
